// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__2_PLW","gfeWrapper":"CalendarEvent_gfeWrapper__eoYt5"};